module.exports = __webpack_public_path__ + "img/icon-american-express.a7cc9999.svg";